import { call } from "redux-saga/effects";

let getHorizontalAddressModule = null;
export function* getHorizontalAddress(params) {
  if (!getHorizontalAddressModule) {
    getHorizontalAddressModule = yield call(() => import("./get-horizontal-address"));
  }
  //llamada a modulo
  yield call(getHorizontalAddressModule.getHorizontalAddresses, params);
}

let getVerticalAddressModule = null;
export function* getVerticalAddress(params) {
  if (!getVerticalAddressModule) {
    getVerticalAddressModule = yield call(() => import("./get-vertical-address"));
  }
  //llamada a modulo
  yield call(getVerticalAddressModule.getVerticalAddresses, params);
}